import { Plus as Plus_phosphor } from './Plus.phosphor';
import { Plus as Plus_zoomg } from './Plus.zoomg';
import { Plus as Plus_zoomit } from './Plus.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'zoomg':
      return Plus_zoomg;

    case 'phosphor':
      return Plus_phosphor;

    default:
      return Plus_zoomit;
  }
};

export const Plus = IconRenderer();
